import { Location } from '@angular/common';
import { Component, HostBinding, OnInit } from '@angular/core';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
})
export class NotFoundComponent implements OnInit {
  @HostBinding('class.full-width-container') classBinding = true;
  showBackButton = false;

  constructor(private location: Location) {}

  ngOnInit(): void {
    this.showBackButton = window.history.length > 1;
  }

  back(): void {
    this.location.back();
  }
}
